import { logout } from 'module/authentication/utils/logout';
import { IconShell } from 'module/ui/components/atoms/icon-shell';
import { Loading } from 'module/ui/components/atoms/loading';
import { ProductiveHeading03 } from 'module/ui/components/styles';
import { Space } from 'antd';
import React, { FC, useEffect } from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  height: 100vh;
  align-items: center;
  justify-content: center;
`;
const Message = styled.div`
  ${ProductiveHeading03};
`;

interface Props {
  postLogoutUrl: string;
}
export const LogoutPage: FC<Props> = ({ postLogoutUrl }) => {
  useEffect(() => {
    logout(postLogoutUrl);
  });

  return (
    <Container>
      <Space align="center" direction="vertical" size={24}>
        <IconShell size="large" icon={<Loading size="large" />} />
        <Message>
          <FormattedMessage id="logging_out" />
        </Message>
      </Space>
    </Container>
  );
};
